export type DesignHistory<T> = {
  past: T[];
  present: T;
  future: T[];
  interaction: number | null;
};

export const createDesignHistory = <T>(present: T): DesignHistory<T> => ({
  past: [],
  present,
  future: [],
  interaction: null,
});

export const recordDesignHistory = <T>(
  history: DesignHistory<T>,
  present: T,
  interaction: number
): DesignHistory<T> => ({
  past:
    history.interaction === interaction
      ? history.past
      : [...history.past, history.present].slice(-50),
  present,
  future: [],
  interaction,
});

export const undoDesignHistory = <T>(
  history: DesignHistory<T>
): DesignHistory<T> => {
  const present = history.past.at(-1);
  if (present === undefined) return history;
  return {
    past: history.past.slice(0, -1),
    present,
    future: [history.present, ...history.future],
    interaction: null,
  };
};

export const redoDesignHistory = <T>(
  history: DesignHistory<T>
): DesignHistory<T> => {
  const present = history.future[0];
  if (present === undefined) return history;
  return {
    past: [...history.past, history.present],
    present,
    future: history.future.slice(1),
    interaction: null,
  };
};
